import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent implements OnInit {
  isConnexionPage = false;
  hideLayout = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isConnexionPage = window.location.href.includes('connexion');
    }
    this.router.events.subscribe(() => {
      const urlWithoutAnchor = this.router.url.split('?')[0].split('#')[0];
      this.hideLayout = urlWithoutAnchor === '/';
    });
  }
}
